// Hand-rolled smooth scroll, driven frame-by-frame via plain (instant)
// window.scrollTo calls, rather than the browser's native
// `scrollTo({ behavior: 'smooth' })`. The native version turned out to be
// unreliable — Chrome would sometimes silently ignore it entirely (verified
// with a completely blank, app-free page, so it's a platform quirk, not
// something in this app's CSS). Driving our own animation sidesteps that.
export function smoothScrollTo(targetY, duration = 450) {
  const startY = window.scrollY;
  const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  const clampedTarget = Math.max(0, Math.min(targetY, maxY));
  const diff = clampedTarget - startY;
  if (Math.abs(diff) < 1) return;

  const startTime = performance.now();

  function step(now) {
    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
    window.scrollTo(0, startY + diff * eased);
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}
